// @ts-nocheck
import * as React from "react";
import { Ic, siteName, brandParts, supportPhone } from "./common";

// Forgot password — 비밀번호 찾기
// Reached from auth.tsx "비밀번호 찾기" link. Two-step UX: request → sent.

function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [phase, setPhase] = React.useState("input"); // input | sent
  const [loading, setLoading] = React.useState(false);

  // POST /api/v1/password_resets. 보안상 어떤 응답이든 "sent" phase로 전환 —
  // 백엔드도 202 고정 응답이라 enumeration 노출 없음. 네트워크 오류만 사용자에게 알림.
  const submit = async (e) => {
    if (e) e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await fetch("/api/v1/password_resets", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ email }),
      });
      setPhase("sent");
    } catch (e) {
      alert(e.message || "네트워크 오류 — 잠시 후 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app" style={{display:'grid', gridTemplateColumns:'1fr 1fr', height:'100%', background:'var(--bg)'}}>
      <div style={{padding:'48px 56px', background:'linear-gradient(160deg, #2A241F 0%, #3F342C 60%, #5A4434 100%)', color:'#F5EBD8', position:'relative', overflow:'hidden', display:'flex', flexDirection:'column'}}>
        <a href="/" style={{display:'flex', alignItems:'center', gap:10, color:'inherit', textDecoration:'none'}}>
          <div className="brand-mark" style={{width:32, height:32}}>{brandParts(siteName()).mark}</div>
          <div>
            <div style={{fontWeight:800, fontSize:15, color:'#fff'}}>{brandParts(siteName()).name}</div>
            {brandParts(siteName()).sub && <div style={{fontSize:10, color:'#A89A7C', letterSpacing:'0.06em'}}>{brandParts(siteName()).sub}</div>}
          </div>
        </a>

        <div style={{marginTop:60}}>
          <div style={{fontSize:11, color:'var(--orange-300)', fontWeight:700, letterSpacing:'0.08em', marginBottom:14}}>비밀번호 재설정</div>
          <h1 style={{fontSize:36, fontWeight:800, lineHeight:1.25, letterSpacing:'-0.02em', margin:0, color:'#fff'}}>
            계정에 등록된<br/>이메일을 알려주세요.
          </h1>
          <p style={{fontSize:14, lineHeight:1.7, color:'#D4C9B2', marginTop:18, maxWidth:380}}>
            가입하실 때 등록한 이메일 주소로 비밀번호 재설정 링크를 보내드립니다. 링크는 30분 동안 유효합니다.
          </p>
        </div>

        <div style={{marginTop:'auto', background:'rgba(255,255,255,0.06)', backdropFilter:'blur(8px)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:18, padding:20}}>
          <div style={{fontSize:11, color:'var(--orange-300)', fontWeight:700, letterSpacing:'0.06em', marginBottom:10}}>도움이 필요하신가요?</div>
          <div style={{display:'flex', gap:10, alignItems:'flex-start', padding:'10px 0', borderTop:'1px solid rgba(255,255,255,0.05)'}}>
            <span style={{width:24,height:24,borderRadius:'50%',background:'rgba(232,130,91,0.2)',color:'#EFB287',display:'grid',placeItems:'center'}}>
              <span style={{width:14,height:14,display:'inline-block'}}>{Ic.phone}</span>
            </span>
            <div style={{fontSize:12, color:'#fff', lineHeight:1.6}}>
              <b>고객지원 {supportPhone()}</b><br/>
              <span style={{color:'#A89A7C', fontSize:11}}>평일 09:00–18:00 · 이메일을 잊으셨다면 본인확인 후 도와드립니다.</span>
            </div>
          </div>
          <div style={{display:'flex', gap:10, alignItems:'flex-start', padding:'10px 0', borderTop:'1px solid rgba(255,255,255,0.05)'}}>
            <span style={{width:24,height:24,borderRadius:'50%',background:'rgba(232,130,91,0.2)',color:'#EFB287',display:'grid',placeItems:'center'}}>
              <span style={{width:14,height:14,display:'inline-block'}}>{Ic.approve}</span>
            </span>
            <div style={{fontSize:12, color:'#fff', lineHeight:1.6}}>
              <b>관리자 계정</b><br/>
              <span style={{color:'#A89A7C', fontSize:11}}>관리자(권역·플랫폼)는 보안 정책에 따라 시스템 관리자가 직접 재설정해 드립니다.</span>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={submit} style={{padding:'48px 56px', display:'flex', flexDirection:'column', overflow:'auto'}}>
        <div style={{display:'flex', justifyContent:'flex-end', fontSize:12, color:'var(--ink-3)'}}>
          기억나셨나요? <a href="/login" style={{color:'var(--orange-600)', fontWeight:700, marginLeft:6, textDecoration:'none'}}>로그인으로 돌아가기 →</a>
        </div>

        {phase === 'input' && (
          <>
            <div style={{margin:'52px 0 28px'}}>
              <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>비밀번호 찾기</h2>
              <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8}}>가입 시 등록한 이메일을 입력해 주세요.</p>
            </div>

            <div className="label">이메일</div>
            <input className="input" type="email" autoComplete="email" required
              value={email} onChange={e=>setEmail(e.target.value)}
              placeholder="name@care.local" style={{marginBottom:14}}/>

            <button type="submit" disabled={loading || !email} className="btn btn-primary btn-lg" style={{marginTop:8, width:'100%'}}>
              {loading ? '메일 발송 중…' : '재설정 링크 받기 →'}
            </button>

          </>
        )}

        {phase === 'sent' && (
          <>
            <div style={{margin:'52px 0 28px'}}>
              <div style={{width:48, height:48, borderRadius:12, background:'var(--green-50)', color:'var(--green-600)', display:'grid', placeItems:'center', marginBottom:18}}>
                <span style={{width:24, height:24, display:'inline-block'}}>{Ic.check}</span>
              </div>
              <h2 style={{fontSize:28, fontWeight:800, letterSpacing:'-0.02em', margin:0}}>메일을 확인해 주세요</h2>
              <p style={{color:'var(--ink-3)', fontSize:13, marginTop:8, lineHeight:1.7}}>
                <b style={{color:'var(--ink-1)'}}>{email}</b> 으로 비밀번호 재설정 링크를 보냈습니다.<br/>
                메일이 보이지 않으면 스팸함도 확인해 주세요.
              </p>
            </div>

            <div style={{padding:18, background:'var(--bg-sub)', borderRadius:14, display:'flex', gap:14, alignItems:'center'}}>
              <span style={{width:42, height:42, borderRadius:12, background:'var(--surface)', display:'grid', placeItems:'center', color:'var(--orange-600)'}}>
                <span style={{width:22, height:22, display:'inline-block'}}>{Ic.clock}</span>
              </span>
              <div style={{flex:1}}>
                <div style={{fontWeight:700, fontSize:13}}>링크는 30분 동안 유효합니다</div>
                <div style={{fontSize:11.5, color:'var(--ink-3)', marginTop:2}}>보안을 위해 한 번만 사용할 수 있습니다.</div>
              </div>
            </div>

            <button type="button" onClick={()=>setPhase('input')} className="btn btn-ghost btn-md" style={{marginTop:20}}>다른 이메일로 다시 보내기</button>
            <a href="/login" className="btn btn-primary btn-lg" style={{marginTop:10, textDecoration:'none', display:'flex', justifyContent:'center'}}>로그인 화면으로 →</a>
          </>
        )}
      </form>
    </div>
  );
}

export { ForgotPassword };
